module.exports = __webpack_public_path__ + "static/elephant3-d5bcfa5d11e9edf8d2e30d87fddd6ea8.jpeg";